interface QuoteErrorProps {
    errors: string[];
}

const QuoterError = ({ errors }: QuoteErrorProps) => {
    return (
        <div className="text-quote-section dynamic-margin">
            <div id="get-quote-container">
                <div id="get-quote-content">
                    <div className="spaced-section">
                        <h2>
                            Unfortunately, this quote couldn't be completed.
                        </h2>
                        {errors && errors.length > 0 &&
                            <>
                                <p>The reasons for this are:</p>
                                <pre>{errors.join("\n")}</pre>
                            </>
                        }
                    </div>
                </div>
            </div>
        </div>
    );
};

export default QuoterError;
